import { IReactionDisposer, reaction } from 'mobx';
import difference from 'lodash/difference';
import { IIdentifiable } from '../../store/storeSchema';

/**
 * Utility observer which monitors the provided reaction for changes in the array configuration
 * and reports when elements are added or removed from the array.
 * This observer is designed to operate on StoreNodes, however it is only required for the provided objects to implement IIdentifiable.
 */
export function arrayDiffObserver(
  tracker: () => IIdentifiable[],
  onAdd: (id: string) => void,
  onRemove: (id: string) => void): IReactionDisposer {

  // it would be simpler to use `observe` and get access to the changes object
  // (which reports array additions and removals)
  // however `observe` would trigger the event immediately after the change has been made and might be triggered
  // before update are made elswhere

  return reaction(tracker, (currVal, prevVal) => {
    const currIds = currVal.map(item => item.id);
    const prevIds = prevVal.map(item => item.id);

    // can be optimized, but for just a few moments at a time shouldn't be a big performance issue
    const addedIds = difference(currIds, prevIds);
    const removedIds = difference(prevIds, currIds);

    for (const id of addedIds)
      onAdd(id);
    for (const id of removedIds)
      onRemove(id);
  });
}